// extracted by mini-css-extract-plugin
export default {"location":"Location_location__MvjG7","type":"Location_type__2M2Ti","selected":"Location_selected__L+PQl"};